export default "__VITE_ASSET__8967cfae__"